import * as React from 'react';
import { Box, Tab, Tabs } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

interface BumbleTabsProps {
  tabs: { el: React.ReactNode; label: string; id: number }[];
}
export default function BumbleTabs({ tabs }: BumbleTabsProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange}>
          {tabs.map(({ label, id }) => (
            <Tab key={id} label={label} {...a11yProps(id)} />
          ))}
        </Tabs>
      </Box>
      {tabs.map(({ el, id }) => (
        <TabPanel key={id} value={value} index={id}>
          {el}
        </TabPanel>
      ))}
    </Box>
  );
}
